import { DownloadBehaviorsActionTypes } from '../constants/downloadBehaviorsForRawDataConstant';

const initialState = {
    clientsForBehaviorDownload: null,
    behaviorsByClientIds: null,
    downloadBehaviorsForRawDataLoading: false
};

export default function downloadBehaviorsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.REQUEST:
            return {
                ...state,
                downloadBehaviorsForRawDataLoading: true,
            };
        case DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.SUCCESS:
            return {
                ...state,
                downloadBehaviorsForRawDataLoading: false,
            };
        case DownloadBehaviorsActionTypes.post_DownloadBehaviorsForRawData.FAILURE:
            return {
                ...state,
                downloadBehaviorsForRawDataLoading: false,
            };
        case DownloadBehaviorsActionTypes.get_ClientsForBehaviorDownload.REQUEST:
            return {
                ...state,
                loading: true,
                clientsForBehaviorDownload: null,
            };
        case DownloadBehaviorsActionTypes.get_ClientsForBehaviorDownload.SUCCESS:
            return {
                ...state,
                loading: false,
                clientsForBehaviorDownload: payload,
            };
        case DownloadBehaviorsActionTypes.get_ClientsForBehaviorDownload.FAILURE:
            return {
                ...state,
                loading: false,
                clientsForBehaviorDownload: null,
            };
        case DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.REQUEST:
            return {
                ...state,
                loading: true,
                behaviorsByClientIds: null,
            };
        case DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.SUCCESS:
            return {
                ...state,
                loading: false,
                behaviorsByClientIds: payload,
            };
        case DownloadBehaviorsActionTypes.get_BehaviorsByClientIds.FAILURE:
            return {
                ...state,
                loading: false,
                behaviorsByClientIds: null,
            };
        case DownloadBehaviorsActionTypes.pst_DownloadTargetForUploadingRawData.REQUEST:
            return {
                ...state,
                loading: true,
                
            };
        case DownloadBehaviorsActionTypes.pst_DownloadTargetForUploadingRawData.SUCCESS:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
} 


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargetsBehaviors/reducers/downloadBehaviorsForRawDataReducer.js